import * as types from './OrderCollectionTypes';
import { assign } from '../../../../shared/Assign';
import InitialState from './OrderCollectionInitialState';

export default function orderCollectionReducer(
    state: any = InitialState.state,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.GET_ORDER_COLLECTION_SUCCESS: {
            const newState = assign({}, state);
            newState.model = action.result;
            return newState;
        }

        default:
            return state;
    }
}
